import React from "react"

function FormulaReward() {
    return (
        <div className="formulaRewardText">
            <h3>The substance found at the scene is</h3>
            <div className="redHighlight">
                <h1>LIPSTICK!</h1> 
            </div>
            <h3>Only three of our remaining suspects have been known to wear lipstick. That means <mark className="yellowTab">Nigel Haysmith</mark> can be eliminated as a suspect.</h3>
        </div>
    )
}

export default FormulaReward